<div class="main-modal-container">
    <!-- Modal Header -->
    <div class="cross-btn-cont">
        <div cygovSvgIcon [svgName]="'x-icon-type2'" class='cross-btn'
            (click)="resetAndClosePopup()">
        </div>
    </div>

    <!-- Modal Body -->
    <div class="lato-18-n-vw dynamic-label-popup-body dynamic-label-bulk-upload-cont">
        <div class="steps-toggle-icons-cont">
            <ng-container *ngFor="let step of steps; let i = index">
                <div
                    [ngClass]="['bulk-dynamic-label-step', 'bulk-'+step?.num?.toLowerCase()+'-step']">
                    <div class="round-checkbox">
                        <input [id]="'label-step-icon'+i" type="radio" [name]="'step-icon'+i"
                            disable [checked]="step.active || step.completed" />
                        <label [for]="'label-step-icon'+i"
                            class="lato-14-n-vw capitalize label standard disable">
                        </label>

                        <div cygovSvgIcon [svgName]="'right-tick'" class="completed-right-tick"
                            [ngClass]="{ 'opacity-class': step.completed}">
                        </div>
                    </div>
                    <div class='round-checkbox-label'>
                        <span class='lato-14-n-vw'
                            [ngClass]="{'disabled-color':!step.active && !step.completed, 'txt-blue':step.active && !step.completed }">{{
                            step.title }}</span>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class='steps-toggle-body'>
            <!-- First Step: Download Template -->
            <ng-container *ngIf="steps[0].active">
                <ng-container *ngTemplateOutlet="stepFirst;">
                </ng-container>
            </ng-container>

            <!-- Second Step: Upload Template -->
            <ng-container *ngIf="steps[1].active">
                <ng-container *ngTemplateOutlet="stepSecond;">
                </ng-container>
            </ng-container>

            <!-- Third Step: Results -->
            <ng-container *ngIf="steps[2].active">
                <div class="bulk-dynamic-label-third-step-content">
                    <!-- Upload Results Summary -->
                    <div class="upload-results-header">
                        <div class="upload-results-title">
                            <span class="lato-18-n-vw">Upload Results:</span>
                            <span class="lato-14-n-vw results-summary">
                                <span class="cleared-count">{{ uploadResult?.cleared || 0 }}
                                    Cleared</span>
                                <span class="failed-count" *ngIf="uploadResult?.failed > 0">
                                    &nbsp;{{ uploadResult?.failed }} Failed:
                                    <!-- <span
                                        *ngFor="let failed of uploadResult?.failedItems?.slice(0, 3); let i = index">
                                        #{{ failed?.rowNumber || i + 1 }}<span
                                            *ngIf="i < 2 && i < uploadResult?.failedItems?.length - 1">,
                                        </span>
                                    </span>
                                    <span *ngIf="uploadResult?.failedItems?.length > 3">,
                                        more...</span> -->
                                </span>
                            </span>
                        </div>
                        <div class="upload-results-actions">
                            <div cygovSvgIcon [svgName]="'trash-icon'"
                                class="trash-icon cursor-pointer" (click)="clearUploadResults()">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dynamic-label-manager-container-wrapper">
                    <ng-container
                        *ngTemplateOutlet="stepThird; context: { items: filteredDynamicLabelManagerItems.tags, title: filteredDynamicLabelManagerItems.tagsTitle, type: filteredDynamicLabelManagerItems.type, searchObj: 'tagSearchText'}">
                    </ng-container>
                    <ng-container
                        *ngTemplateOutlet="stepThird; context: { items: filteredDynamicLabelManagerItems.categories, title: filteredDynamicLabelManagerItems.categoriesTitle, type: filteredDynamicLabelManagerItems.type, searchObj: 'categorySearchText' }">
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Modal Footer -->
    <div class="lato-22-n-vw dynamic-label-popup-footer">
        <cygov-button *ngIf="!steps[0].active" class="button-margin"
            [buttonText]="'< Previous Step'" [buttonColor]="'#030715'" [buttonWidth]="'auto'"
            [textColor]="'#C5C9D1'" (buttonPressed)="moveBackToOldStep()"
            [disableClick]="disableBackBtn">
        </cygov-button>
        <cygov-button class="button-margin" [buttonText]="nextStepBtnText" [buttonWidth]="'5.1vw'"
            [buttonColor]="'#29a9eb'" [hoverColor]="'#0F92E3'" (buttonPressed)="moveToNextStep()"
            [disableClick]="disableBtn">
        </cygov-button>
    </div>
</div>


<!-- ============= First Step Content: Download Template ================= -->
<ng-template #stepFirst>
    <div class="bulk-dynamic-label-step-content abs-centre">
        <div class='download-csv-box cursor-pointer' (click)="downloadCSVTemplate()">
            <div class='download-btn-icon abs-centre'>
                <div cygovSvgIcon [svgName]="'download-report-icon'" class='download-icon-svg'>
                </div>
            </div>
            <div class='download-btn-text lato-25-n-vw'>
                Download Template
            </div>
        </div>
    </div>
</ng-template>

<!-- ============= Second Step Content: Upload Template ================= -->
<ng-template #stepSecond>
    <div class="bulk-dynamic-label-step-content bulk-dynamic-label-second-step-content abs-centre">
        <cygov-upload-file [uploadPath]='""' [uploadType]="'.xlsx'" [restrictFileDrop]="'.xlsx'"
            [displayMessage]="'Uploading Template'" [loaderType]="uploadStateEnum.STYLE1"
            [requiredInfo]="requiredInfo" [isFakeUpload]="true" [invalidFile]="invalidFileData"
            [multiSelect]="false" [customMessage]="'Drag template here or '">
        </cygov-upload-file>
    </div>
</ng-template>

<!-- ============= Third Step Content: Results ================= -->
<ng-template #stepThird let-items="items" let-title="title" let-type="type"
    let-searchObj="searchObj">

    <div class="dynamic-label-manager-container">
        <div class="dynamic-label-manager-container-header">
            <div class="title lato-18-n-vw">{{ title }}</div>
            <span class="add-tag-icon" cygovSvgIcon [svgName]="'add-icon'"
                (click)="showAddBoxForTagOrCategory(title)"></span>
        </div>
        <div class="dynamic-label-manager-container-search-bar">
            <div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
            <input type="text" class="form-control search" aria-label="Search" placeholder="Search"
                name="search" [(ngModel)]="searchFormObject[searchObj]"
                (keyup)="searchDynamicLabelManagerItems(searchFormObject[searchObj], title, type)"
                spellcheck="true" />
        </div>
        @if(title !== 'Policy Categories') {
        <div class="dynamic-label-manager-container-content">
            @for (item of items; track item; let i = $index) {
            <div class="dynamic-label-manager-container-content-item">
                <input id="item{{ item.id }}" name="item{{ item.id }}" type="checkbox"
                    [checked]="item.selected" (change)="selectDynamicLabelManagerItem(item)" />
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !item.name}" autofocus
                    [(ngModel)]="item.name" />
            </div>
            @if (i === 0 && isAddEnabled && currentSelectedSection === title) {
            <div class="custom-add-box">
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !newTagValue}" autofocus
                    [(ngModel)]="newTagValue" />
                <div class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">
                    <span>×</span>
                </div>
                <button class="add-btn lato-12-n-vw"
                    (click)="addNewTagOrCategory(title, null, type)">Add</button>
            </div>
            }
            }
            @if(items.length === 0 && isAddEnabled && currentSelectedSection === title){
            <div class="custom-add-box">
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !newTagValue}" autofocus
                    [(ngModel)]="newTagValue" />
                <div class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">
                    <span>×</span>
                </div>
                <button class="add-btn lato-12-n-vw"
                    (click)="addNewTagOrCategory(title, null, type)">Add</button>
            </div>
            }
        </div>
        }
        @else {
        <div class="dynamic-label-manager-container-content">
            <!-- Header and add button -->
            @for (item of items; track item; let i = $index) {
            @if(i === 0 && isAddEnabled && currentSelectedSection === title) {
            <div class="dynamic-label-manager-container-content-header">
                <div class="custom-add-box">
                    <input type="text" name="newTag" class="custom-add-input"
                        [ngClass]="{'custom-add-input-empty': !newTagValue}" autofocus
                        [(ngModel)]="newTagValue" />
                    <span class="custom-add-close"
                        (click)="closeAddBoxForTagOrCategory(title)">×</span>
                    <button class="add-btn lato-12-n-vw"
                        (click)="addNewTagOrCategory(title, null, type)">Add</button>
                </div>
                <span class="add-tag-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
            </div>
            <div class="horiz-seprator"></div>
            }
            <div class="dynamic-label-manager-container-content-header">
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !item.name}" autofocus
                    [(ngModel)]="item.name" />
                <span class="add-tag-icon" cygovSvgIcon [svgName]="'add-icon'"
                    (click)="showAddBoxForTagOrCategory(item.name)"></span>
            </div>
            <div class="horiz-seprator"></div>
            @for (subValue of item.values; track subValue; let j = $index) {
            <div class="dynamic-label-manager-container-content-item">
                <input id="item{{ subValue.id }}" name="item{{ subValue.id }}" type="checkbox"
                    [checked]="subValue.selected"
                    (change)="selectDynamicLabelManagerItem(subValue)" />
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !item.name}" autofocus
                    [(ngModel)]="subValue.name" />
            </div>
            @if (j === 0 && isAddEnabled && currentSelectedSection === item.name) {
            <div class="custom-add-box">
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !newTagValue}" autofocus
                    [(ngModel)]="newTagValue" />
                <div class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">
                    <span>×</span>
                </div>
                <button class="add-btn lato-12-n-vw"
                    (click)="addNewTagOrCategory(title, item.name, type)">Add</button>
            </div>
            }
            }
            @if(item.values.length === 0 && isAddEnabled && currentSelectedSection ===
            item.name){
            <div class="custom-add-box">
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !newTagValue}" autofocus
                    [(ngModel)]="newTagValue" />
                <div class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">
                    <span>×</span>
                </div>
                <button class="add-btn lato-12-n-vw"
                    (click)="addNewTagOrCategory(title, item.name, type)">Add</button>
            </div>
            }
            }

            @if(items.length === 0 && isAddEnabled && currentSelectedSection === title){
            <div class="custom-add-box">
                <input type="text" name="newTag" class="custom-add-input"
                    [ngClass]="{'custom-add-input-empty': !newTagValue}" autofocus
                    [(ngModel)]="newTagValue" />
                <div class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">
                    <span>×</span>
                </div>
                <button class="add-btn lato-12-n-vw"
                    (click)="addNewTagOrCategory(title, null, type)">Add</button>
            </div>
            }

        </div>
        }
    </div>
</ng-template>